import ProjectExpertPodsComponent from './project-expert-pods.component'

const ProjectExpertPodsModule = angular.module('cdbl.project-expert-pods', [

])
  .component('cdblProjectExpertPods', ProjectExpertPodsComponent)
  .name

export default ProjectExpertPodsModule
